import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=78954d32&scoped=true&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=78954d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78954d32",
  null
  
)

export default component.exports